import { Typography, Input } from '@evocolabs/orkaui'
import { useEffect, useState } from 'react'
import Fuse from 'fuse.js'
import Search24 from '@evocolabs/icons/lib/Search24'
import SearchResult120 from '@evocolabs/icons/lib/SearchResult120'
import Close24 from '@evocolabs/icons/lib/Close24'
import { Box } from '@mui/material'
import Link from 'next/link'
import styles from '@/pages/scss/FAQ.module.scss'
import { MoreQuestions } from '@/src/components/FAQ/FAQUtils'
import Header from '@/src/components/HeaderV2'

const ResultItem = ({ keywords, qst, link, content }) => {
  let innerHTML = qst
  let innerHTMLCntt = content
  innerHTMLCntt = innerHTMLCntt.replace(/<.*?>/g, '')
  const keywordsFiltered = keywords.filter(
    (keyword) =>
      !(keyword === '' || keyword === ' ' || !keyword.match(/^[a-z0-9\-]+$/i))
  )
  // truncate
  let fstKeywordIdx = Infinity
  keywordsFiltered.forEach((keyword) => {
    const resExpSearch = innerHTMLCntt.match(
      new RegExp(`(\\b${keyword})`, 'gi')
    )
    let tmpIdx = -1
    if (resExpSearch) {
      tmpIdx = innerHTMLCntt.indexOf(resExpSearch[0])
    }
    if (tmpIdx >= 0) {
      fstKeywordIdx = Math.min(fstKeywordIdx, tmpIdx)
    }
  })
  if (fstKeywordIdx === Infinity) {
    fstKeywordIdx = 0
  }
  let startFromStart = true
  if (fstKeywordIdx > 25) {
    startFromStart = false
  }
  fstKeywordIdx = Math.max(0, fstKeywordIdx - 25)
  innerHTMLCntt =
    (startFromStart ? '' : '...') +
    innerHTMLCntt.substring(fstKeywordIdx, fstKeywordIdx + 90) +
    '...'
  if (keywordsFiltered) {
    // add label for highlights
    keywordsFiltered.sort((a, b) => b.length - a.length)
    keywordsFiltered.forEach((keyword) => {
      innerHTML = innerHTML.replace(
        new RegExp(`(\\b${keyword})`, 'gi'),
        `[__START__]$1[__END__]`
      )
      innerHTMLCntt = innerHTMLCntt.replace(
        new RegExp(`(\\b${keyword})`, 'gi'),
        `[__START__]$1[__END__]`
      )
    })
  }
  innerHTML = innerHTML.replace(
    /\[__START__\]/g,
    `<span class=${styles.keywords}>`
  )

  innerHTMLCntt = innerHTMLCntt.replace(
    /\[__START__\]/g,
    `<span class=${styles.keywords}>`
  )
  innerHTML = innerHTML.replace(/\[__END__\]/g, '</span>')
  innerHTMLCntt = innerHTMLCntt.replace(/\[__END__\]/g, '</span>')
  return (
    <Box className={styles.resultItemWrapper}>
      <Link href={link}>
        <Typography
          variant="subh1"
          dangerouslySetInnerHTML={{ __html: innerHTML }}
        />
        <Typography
          mt={0.5}
          variant="body2"
          sx={{ color: '#404040' }}
          dangerouslySetInnerHTML={{ __html: innerHTMLCntt }}
        />
      </Link>
    </Box>
  )
}

const ResultSection = ({ searchInput, data }) => {
  if (searchInput === '') return <></>
  const keywords = searchInput.split(' ')
  const options = {
    includeScore: true,
    ignoreLocation: true,
    keys: ['question', 'content', 'section'],
    threshold: 0.15
  }
  const fuse = new Fuse(data.results.data, options)
  const result = fuse.search(searchInput)
  return (
    <Box className={styles.resultSection}>
      {result.map((d, id) => {
        return (
          <ResultItem
            qst={d.item.question}
            content={d.item.content}
            qst_id={d.item.id}
            link={`/FAQ/qst/${d.item.id}?frompage=search`}
            keywords={keywords}
            key={id}
          />
        )
      })}
      {!result.length && (
        <Box className={styles.noResultWrapper}>
          <SearchResult120 />
          <Typography variant="body1">
            No results for “{searchInput}”
          </Typography>
        </Box>
      )}
      <MoreQuestions section_name={'search'} />
    </Box>
  )
}
export const SearchSection = ({ data }) => {
  const [searchInput, setSearchInput] = useState('')
  useEffect(() => {
    const cacheInput = window.sessionStorage.getItem('faq_search_input')
    if (cacheInput) {
      setSearchInput(cacheInput)
      document.getElementById('searchInputBox').value = cacheInput
    }
  }, [])
  return (
    <>
      <Box className={styles.searchPageHeader}>
        <Box padding="66px 12px 16px" className={styles.searchWrapper}>
          <Input
            id="searchInputBox"
            variant="outlined"
            fullWidth
            className={styles.searchBox}
            placeholder="Search for questions"
            icon={<Search24 />}
            endAdornment={
              searchInput && (
                <span
                  onClick={() => {
                    setSearchInput('')
                    document.getElementById('searchInputBox').value = ''
                  }}
                  style={{ lineHeight: 0 }}
                >
                  <Close24 />
                </span>
              )
            }
            onChange={(e) => {
              setSearchInput(e.target.value)
              window.sessionStorage.setItem('faq_search_input', e.target.value)
            }}
          />

          <Link href="/FAQ">
            <Typography variant="subh2" className={styles.cancelButton}>
              Cancel
            </Typography>
          </Link>
        </Box>
      </Box>
      <ResultSection data={data} searchInput={searchInput} />
    </>
  )
}

const SearchPage = ({ data }) => {
  useEffect(() => {
    document.getElementById('searchInputBox').focus()
  })
  return (
    <>
      <Header isWhiteBg />
      <SearchSection data={data} />
    </>
  )
}

export async function getStaticProps() {
  const url = process.env.NEXT_PUBLIC_BASEURL + 'faq/'
  const res = await fetch(url)
  const data = await res.json()
  return { props: { data }, revalidate: 60 }
}

export default SearchPage
